import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=51b6c496&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b6c496')) {
      api.createRecord('51b6c496', component.options)
    } else {
      api.reload('51b6c496', component.options)
    }
    module.hot.accept("./Content.vue?vue&type=template&id=51b6c496&", function () {
      api.rerender('51b6c496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wla/Content.vue"
export default component.exports